<template>
  <div class="player">
    <img v-bind:src="picture" v-if="picture"/>
    <img src="../assets/default-profile.png" v-else/>
    <bs-dropdown :text="username" size="sm" variant="link" no-caret v-if="!isMe">
      <bs-dropdown-item v-bind:to="`/profiles/${userId}`">
        <img src="/static/eye.svg"/>Voir le profil</bs-dropdown-item>
      <bs-dropdown-item-button v-on:click="addToFriends" v-if="!isFriend">
        <img src="/static/user-plus.svg"/>Ajouter à mes amis</bs-dropdown-item-button>
      <bs-dropdown-item-button v-on:click="removeFromFriends" v-else>
        <img src="/static/user-times.svg"/>Supprimer de mes amis</bs-dropdown-item-button>
    </bs-dropdown>
    <span v-else>
      {{username}}
    </span>
  </div>
</template>

<script>
import iam from '../iam';
import BsDropdown from './ui/BsDropdown.vue';
import BsDropdownItem from './ui/BsDropdownItem.vue';
import BsDropdownItemButton from './ui/BsDropdownItemButton.vue';

export default {
  name: 'Player',
  components: { BsDropdown, BsDropdownItem, BsDropdownItemButton },
  props: {
    username: {
      type: String,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
    picture: {
      type: String,
      required: false,
    },
  },
  emits: ['refresh-list'],
  data() {
    return {
      user: iam.getConnectedUser(),
    };
  },
  computed: {
    isFriend() {
      const friends = this.user.friends;
      return friends && friends.find(f => f.userId === this.userId);
    },
    isMe() {
      return this.user.id === this.userId;
    },
  },
  methods: {
    addToFriends() {
      const friends = iam.getConnectedUser().friends || [];
      friends.push({
        userId: this.userId,
        username: this.username,
        picture: this.picture,
      });
      this.$http.post(`${import.meta.env.VITE_LCT_API_URL}/friends`, friends)
        .then(() => {
          const user = iam.getConnectedUser();
          user.friends = friends;
          this.user = user;
          iam.setConnectedUser(user);
        });
    },
    removeFromFriends() {
      this.user.friends = iam.getConnectedUser().friends.filter(f => f.userId !== this.userId);
      this.$http.post(`${import.meta.env.VITE_LCT_API_URL}/friends`, this.user.friends)
        .then(() => {
          iam.setConnectedUser(this.user);
          this.$emit('refresh-list');
        });
    },
  },
};
</script>
<style scoped>
  .player {
    position: relative;
  }
  .player span{
    padding: 0.25rem 0.5rem;
  }
  img{
    width: 40px;
    margin-right: 4px;
  }
</style>
